/**
 * Utility functions for API requests
 *
 * These are kept separate from api/request.ts so they don't need special handling in tests.
 * When you mock "src/api/request", these utilities remain unmocked and work normally.
 */

/**
 * Helper to safely map array responses
 * Returns an empty array if response is not an array
 *
 * @example
 * const users = mapArrayResponse(response, (item) => new User(item.id, item.name));
 */
export function mapArrayResponse<T, R>(response: T, mapper: (item: any) => R): R[] {
  return Array.isArray(response) ? response.map(mapper) : [];
}

/**
 * Helper to build URLs by replacing path parameters
 *
 * @example
 * buildUrl("/users/:id/posts/:postId", { id: 123, postId: 456 })
 * // => "/users/123/posts/456"
 */
export function buildUrl(template: string, params?: Record<string, string | number>): string {
  if (!params) return template;

  return Object.entries(params).reduce((url, [key, value]) => {
    return url.replace(`:${key}`, String(value));
  }, template);
}
